var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-col",
    { attrs: { cols: "12", md: "2", "ma-1": "" } },
    [
      _c(
        "v-card",
        [
          _c(
            "v-card-title",
            { staticClass: "title font-weight-black" },
            [
              _c("v-icon", { staticClass: "pr-3" }, [_vm._v("list")]),
              _vm._v(" To Do\n        "),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-card-text",
            [
              _c(
                "v-btn",
                { staticClass: "mt-1", attrs: { block: "", href: _vm.allUrl } },
                [_c("v-icon", [_vm._v("list")]), _vm._v(" All")],
                1
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  staticClass: "mt-1",
                  attrs: { block: "", href: _vm.activeUrl },
                },
                [_c("v-icon", [_vm._v("playlist_add")]), _vm._v(" Active")],
                1
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  staticClass: "mt-1",
                  attrs: { block: "", href: _vm.redeemedUrl },
                },
                [
                  _c("v-icon", [_vm._v("playlist_add_check")]),
                  _vm._v(" Redeemed"),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  staticClass: "mt-1",
                  attrs: { block: "", href: _vm.cancelledUrl },
                },
                [
                  _c("v-icon", [_vm._v("cancel_presentation")]),
                  _vm._v(" Cancelled"),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  staticClass: "mt-1",
                  attrs: { block: "", href: _vm.refundedUrl },
                },
                [
                  _c("v-icon", [_vm._v("keyboard_return")]),
                  _vm._v(" Refunded"),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }